module.exports = __webpack_public_path__ + "img/cimb.65abc872.svg";